import { render, staticRenderFns } from "./VitaminsView.vue?vue&type=template&id=30c481b6&scoped=true"
import script from "./VitaminsView.vue?vue&type=script&lang=js"
export * from "./VitaminsView.vue?vue&type=script&lang=js"
import style0 from "./VitaminsView.vue?vue&type=style&index=0&id=30c481b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c481b6",
  null
  
)

export default component.exports